import { FaViber } from 'react-icons/fa';

/* Official Viber logo glyph (Font Awesome, via react-icons) — crisp at any
   size, unlike the hand-drawn attempt. Inherits currentColor, so the
   existing containers color it Viber purple (#7360F2) themselves; CSS
   width/height rules on svg (e.g. .qa svg{width:15px}) still apply. */
const ViberIcon = ({ size = 16, ...rest }) => <FaViber size={size} {...rest} />;

export default ViberIcon;
